/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletActionReqVo
 */
export interface UserWalletActionReqVo {
    /**
     * 钱包数据编号
     * @type {number}
     * @memberof UserWalletActionReqVo
     */
    id: number;
    /**
     * 余额数量
     * @type {number}
     * @memberof UserWalletActionReqVo
     */
    amount: number;
    /**
     * 内容
     * @type {string}
     * @memberof UserWalletActionReqVo
     */
    content?: string;
}

/**
 * Check if a given object implements the UserWalletActionReqVo interface.
 */
export function instanceOfUserWalletActionReqVo(value: object): value is UserWalletActionReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function UserWalletActionReqVoFromJSON(json: any): UserWalletActionReqVo {
    return UserWalletActionReqVoFromJSONTyped(json, false);
}

export function UserWalletActionReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletActionReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount': json['amount'],
        'content': json['content'] == null ? undefined : json['content'],
    };
}

export function UserWalletActionReqVoToJSON(json: any): UserWalletActionReqVo {
    return UserWalletActionReqVoToJSONTyped(json, false);
}

export function UserWalletActionReqVoToJSONTyped(value?: UserWalletActionReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'content': value['content'],
    };
}

